import { CheckboxRenderer } from "@/controls/ag-grid/components/CheckboxRenderer";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CatalogAdjustmentType } from "../../../models/CatalogAdjustmentType";
import { typeUrl } from "../CatalogAdjustmentTypePage";

type Props = {
	setSelectedRowData: (adjustmentType: CatalogAdjustmentType) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "AdjustmentTypeName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "RequiredValue",
			headerName: "Required Value",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
		},
		{
			field: "RequiredReason",
			headerName: "Required Reason",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
		},
		{
			field: "Unit",
			headerName: "Unit",
			minWidth: 20,
			flex: 1,
		},
		{
			headerName: "",
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as CatalogAdjustmentType,
				url: `${typeUrl}/${
					(params.data as CatalogAdjustmentType).AdjustmentTypeId
				}`,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "adjustmentTypeContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			flex: 1,
			minWidth: 200,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
